<script>  
    import { fade } from "svelte/transition";
  let loadingCheckout = true;
 setTimeout(function () {
    loadingCheckout = false;
  }, 10000);
</script>


{#if loadingCheckout}
  <div
    transition:fade={{ duration: 300 }}
    id="loadingCheckout" class="fixed w-screen h-screen top-0 left-0 bg-opacity-50 bg-blue-600 p-10 z-50 items-center justify-center flex text-center" style=""><span class="font-bold p-5 py-2 px-10 bg-gray-200 rounded-full text-orange-600 border-2 border-orange-600 shadow-lg">Memproses ...<br><span class="text-xs font-light">Mohon Tunggu hingga proses selesai</span></span></div>
{/if}